module.exports = __webpack_public_path__ + "img/ge.d3665bf1.svg";